import { LayoutConfig } from './layout.abstract.config';

export const layoutConfig: LayoutConfig = {
  privileges: {
    job: {
      view: 'web:jobs-view',
      create: 'web:jobs-create',
    },
    candidates: {
      view: 'web:candiadtes-view',
      create: 'web:candiadtes-create',
    },
    companies: {
      view: 'web:companies-view',
      create: 'web:companies-create',
    },
    reports: {
      view: 'web:reports-view',
    },
    settings: {
      anonymization: 'web:settings-anonymization',
      user: 'web:settings-users',
      profile: 'web:settings-profile',
    },
    jobBoards: {
      viewPage: 'web:settings-job-boards',
    },
  },
  breakpoints: {
    xs: '0',
    sm: '36rem',
    md: '48rem',
    lg: '62rem',
    xl: '82.5rem',
  },
};
